module.exports = __webpack_public_path__ + "src/app/_content/imgs/mini/id.jpg?0059b34c3eed984cb5bd629413eac026";